import { render, staticRenderFns } from "./BiddingTable.vue?vue&type=template&id=19202150&scoped=true&"
import script from "./BiddingTable.vue?vue&type=script&lang=js&"
export * from "./BiddingTable.vue?vue&type=script&lang=js&"
import style0 from "./BiddingTable.vue?vue&type=style&index=0&id=19202150&lang=scss&scoped=true&"
import style1 from "./BiddingTable.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19202150",
  null
  
)

export default component.exports